// import { posthog } from 'posthog-js';
import { reportError } from '../../lib/errorReports';

interface RecorderErrorContext {
  operation:
    | 'backup_chunk'
    | 'backup_record'
    | 'initialization'
    | 'recording_start';
  errorType: string;
  errorMessage: string;
  errorStack?: string;
  fileId?: string | null;
  partNumber?: number;
  additionalContext?: Record<string, any>;
}

const trackRecorderError = (context: RecorderErrorContext) => {
  const {
    operation,
    errorType,
    errorMessage,
    errorStack,
    fileId,
    partNumber,
    additionalContext,
  } = context;

  // DISABLED: Track exceptions in PostHog properly (too expensive)
  // Create an Error object for proper exception tracking
  // const error = new Error(errorMessage);
  // error.name = errorType;
  // if (errorStack) {
  //   error.stack = errorStack;
  // }

  // posthog.captureException(error, {
  //   tags: {
  //     operation,
  //     hasFileId: !!fileId,
  //   },
  //   extra: {
  //     fileId: fileId || 'null',
  //     partNumber,
  //     timestamp: new Date().toISOString(),
  //     ...additionalContext,
  //   },
  // });

  // Also report to the existing error reporting system for detailed debugging
  reportError(`recorder:${operation}`, {
    error: {
      name: errorType,
      message: errorMessage,
      stack: errorStack,
    },
    context: {
      operation,
      fileId,
      partNumber,
      ...additionalContext,
    },
  });
};

export default trackRecorderError;
